module.exports = __webpack_public_path__ + "static/img/53.aa52f28f.png";